import React from "react";
import { useLoading } from "../../context/LoadingContext";
import CircularProgress from "@mui/material/CircularProgress";

const Loader = () => {
  const { isLoading } = useLoading();

  if (!isLoading) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0, 0, 0, 0.7)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <CircularProgress sx={{color:'#ffffff'}} />
    </div>
  );
};

export default Loader;
